"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeaderModule = /** @class */ (function () {
    function HeaderModule() {
    }
    return HeaderModule;
}());
exports.HeaderModule = HeaderModule;
